<template>
    <div class="table-row-cells">
        <slot></slot>

        <div v-if="showDaysTillEndOfSubscription" v-indicator="matrix.days_till_end_of_subscription" class="table-td cell-2x">
            <span v-if="data.days_till_end_of_subscription === null" class="indicator-item">
                <SvgIcon icon="icon-times-circle-big" />
            </span>
            <span v-else-if="data.days_till_end_of_subscription === 0" class="indicator-item">
                <figure>
                    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.1797 9H13.5V10.25H10.1797V9ZM10.1797 11.5H13.5V12.75H10.1797V11.5ZM15.1797 4.82031H11V2.32031C11 1.42188 10.2578 0.679688 9.32031 0.679688H7.67969C6.74219 0.679688 6 1.42188 6 2.32031V4.82031H1.82031C0.921875 4.82031 0.179688 5.60156 0.179688 6.5V15.6797C0.179688 16.5781 0.921875 17.3203 1.82031 17.3203H15.1797C16.0781 17.3203 16.8203 16.5781 16.8203 15.6797V6.5C16.8203 5.60156 16.0781 4.82031 15.1797 4.82031ZM7.67969 4.82031V2.32031H9.32031V6.5H7.67969V4.82031ZM15.1797 15.6797H1.82031V6.5H6C6 7.39844 6.74219 8.17969 7.67969 8.17969H9.32031C10.2578 8.17969 11 7.39844 11 6.5H15.1797V15.6797ZM4.75 10.25C4.75 9.54688 5.29688 9 6 9C6.70312 9 7.25 9.54688 7.25 10.25C7.25 10.9531 6.70312 11.5 6 11.5C5.29688 11.5 4.75 10.9531 4.75 10.25ZM7.71875 12.4766C7.21094 12.2422 6.625 12.125 6 12.125C5.375 12.125 4.78906 12.2422 4.28125 12.4766C3.8125 12.6719 3.5 13.1406 3.5 13.6484V14H8.5V13.6484C8.5 13.1406 8.1875 12.6719 7.71875 12.4766Z" fill="#A50000"/>
                    </svg>
                </figure>
                {{ __('Today') }}
            </span>
            <span v-else-if="data.days_till_end_of_subscription === 1" class="indicator-item">
                <figure>
                    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.1797 9H13.5V10.25H10.1797V9ZM10.1797 11.5H13.5V12.75H10.1797V11.5ZM15.1797 4.82031H11V2.32031C11 1.42188 10.2578 0.679688 9.32031 0.679688H7.67969C6.74219 0.679688 6 1.42188 6 2.32031V4.82031H1.82031C0.921875 4.82031 0.179688 5.60156 0.179688 6.5V15.6797C0.179688 16.5781 0.921875 17.3203 1.82031 17.3203H15.1797C16.0781 17.3203 16.8203 16.5781 16.8203 15.6797V6.5C16.8203 5.60156 16.0781 4.82031 15.1797 4.82031ZM7.67969 4.82031V2.32031H9.32031V6.5H7.67969V4.82031ZM15.1797 15.6797H1.82031V6.5H6C6 7.39844 6.74219 8.17969 7.67969 8.17969H9.32031C10.2578 8.17969 11 7.39844 11 6.5H15.1797V15.6797ZM4.75 10.25C4.75 9.54688 5.29688 9 6 9C6.70312 9 7.25 9.54688 7.25 10.25C7.25 10.9531 6.70312 11.5 6 11.5C5.29688 11.5 4.75 10.9531 4.75 10.25ZM7.71875 12.4766C7.21094 12.2422 6.625 12.125 6 12.125C5.375 12.125 4.78906 12.2422 4.28125 12.4766C3.8125 12.6719 3.5 13.1406 3.5 13.6484V14H8.5V13.6484C8.5 13.1406 8.1875 12.6719 7.71875 12.4766Z" fill="#A50000"/>
                    </svg>
                </figure>
                {{ __('Tomorrow') }}
            </span>
            <span v-else class="indicator-item">
                <figure>
                    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.1797 9H13.5V10.25H10.1797V9ZM10.1797 11.5H13.5V12.75H10.1797V11.5ZM15.1797 4.82031H11V2.32031C11 1.42188 10.2578 0.679688 9.32031 0.679688H7.67969C6.74219 0.679688 6 1.42188 6 2.32031V4.82031H1.82031C0.921875 4.82031 0.179688 5.60156 0.179688 6.5V15.6797C0.179688 16.5781 0.921875 17.3203 1.82031 17.3203H15.1797C16.0781 17.3203 16.8203 16.5781 16.8203 15.6797V6.5C16.8203 5.60156 16.0781 4.82031 15.1797 4.82031ZM7.67969 4.82031V2.32031H9.32031V6.5H7.67969V4.82031ZM15.1797 15.6797H1.82031V6.5H6C6 7.39844 6.74219 8.17969 7.67969 8.17969H9.32031C10.2578 8.17969 11 7.39844 11 6.5H15.1797V15.6797ZM4.75 10.25C4.75 9.54688 5.29688 9 6 9C6.70312 9 7.25 9.54688 7.25 10.25C7.25 10.9531 6.70312 11.5 6 11.5C5.29688 11.5 4.75 10.9531 4.75 10.25ZM7.71875 12.4766C7.21094 12.2422 6.625 12.125 6 12.125C5.375 12.125 4.78906 12.2422 4.28125 12.4766C3.8125 12.6719 3.5 13.1406 3.5 13.6484V14H8.5V13.6484C8.5 13.1406 8.1875 12.6719 7.71875 12.4766Z" fill="#A50000"/>
                    </svg>
                </figure>
                {{ __choice('{0} :days days|{1} :days day|[2,4] :days days|[5,*] :days days', data.days_till_end_of_subscription, {'days': data.days_till_end_of_subscription}) }}
            </span>
        </div>

        <div v-indicator="matrix.days_since_page_viewed" class="table-td cell-2x">
            <span v-if="!data.days_since_page_viewed" class="indicator-item">
                <figure>
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.67969 3.82031L6.50781 4.99219L8.65625 7.17969H0.179688V8.82031H8.65625L6.50781 11.0078L7.67969 12.1797L11.8203 8L7.67969 3.82031ZM15.1797 13.8203H8.5V15.5H15.1797C16.0781 15.5 16.8203 14.7578 16.8203 13.8203V2.17969C16.8203 1.24219 16.0781 0.5 15.1797 0.5H8.5V2.17969H15.1797V13.8203Z" fill="#008853"/>
                    </svg>
                </figure>
                {{ data.days_since_page_viewed === 0 ? __('Today') : '- ' + __('day') }}
            </span>
            <span v-else class="indicator-item">
                <figure>
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.67969 3.82031L6.50781 4.99219L8.65625 7.17969H0.179688V8.82031H8.65625L6.50781 11.0078L7.67969 12.1797L11.8203 8L7.67969 3.82031ZM15.1797 13.8203H8.5V15.5H15.1797C16.0781 15.5 16.8203 14.7578 16.8203 13.8203V2.17969C16.8203 1.24219 16.0781 0.5 15.1797 0.5H8.5V2.17969H15.1797V13.8203Z" fill="#008853"/>
                    </svg>
                </figure>
                {{ __choice('{0} :days days|{1} :days day|[2,4] :days days|[5,*] :days days', data.days_since_page_viewed, {'days': data.days_since_page_viewed}) }}
            </span>
        </div>

        <!--<div
            v-indicator:[matrix.compliance_in_percentage]="data.compliance_in_percentage"
            class="table-td cell-adherence"
        >
            <span v-if="data.compliance_in_percentage" class="indicator-item">{{ data.compliance_in_percentage }} </span>
            <span v-else class="indicator-item"> - </span>
        </div>-->

        <div
            v-indicator="matrix.average_mood.color"
            class="table-td"
        >
            <MatrixMoodEmoji :average-mood="matrix.average_mood ? matrix.average_mood.mood : null" />
        </div>

        <div v-indicator="matrix.last_weight" class="table-td cell-weight">
            <span class="indicator-item" :class="{ 'no-arrow': data.last_weight }">
                {{ data.last_weight ? numberFormat(data.last_weight) : '-' }} kg
            </span>

            <sup
                v-if="matrix.weight_total_progress"
                v-indicator="matrix.weight_total_progress"
                class="data-total"
            >
                {{ numberFormat(data.weight_total_progress) }}
            </sup>
        </div>

        <div v-indicator="matrix.lessons_done" class="table-td">
            <span class="indicator-item">
                <SvgIcon v-if="data.lessons_done" icon="icon-check-circle-big" />
                <SvgIcon v-else icon="icon-times-circle-big" />
            </span>
        </div>

        <div
            v-indicator="matrix.steps_average_percentage"
            class="table-td cell-steps"
        >
            <span v-if="matrix.steps_average_percentage" class="indicator-item">{{ numberFormat(data.steps_average) }}</span>
            <span v-else class="indicator-item">-</span>
        </div>

        <div v-indicator="$_.isNull(matrix.weekly_eaten_meals_percentage) ? 'white' : matrix.weekly_eaten_meals_percentage" class="table-td">
            <span class="indicator-item">{{ $_.isNull(data.weekly_eaten_meals_percentage) ? ' - ' : `${data.weekly_eaten_meals_percentage} %` }}</span>

            <sup v-if="data.self_evaluation_value" v-indicator="data.self_evaluation_color" class="data-total">
                {{ round(data.self_evaluation_value) }}
            </sup>
        </div>

        <div v-indicator="matrix.last_waist" class="table-td cell-weight">
            <span class="indicator-item" :class="{ 'no-arrow': !data.last_waist }">{{ data.last_waist || '-' }} cm</span>

            <sup
                v-if="matrix.waist_total_progress"
                v-indicator="matrix.waist_total_progress"
                class="data-total"
            >
                {{ numberFormat(data.waist_total_progress) }}
            </sup>
        </div>

        <div v-indicator="matrix.habits_successfully_completed" class="table-td">
            <span class="indicator-item">
                {{ $_.isNull(data.habits_successfully_completed) ? ' - ' : data.habits_successfully_completed }}
            </span>
        </div>

        <div
            class="table-td cell-call call-today"
        >
            <span class="indicator-item">
                <consultation-call-status :call_list="matrix.call_status"></consultation-call-status>
            </span>
        </div>
    </div>
</template>

<script>
import MatrixMoodEmoji from '@components/PatientsMatrix/Cells/MatrixMoodEmoji'
import PatientRowCells from '@components/PatientsMatrix/PatientRowCells'

export default {
    components: {
        MatrixMoodEmoji
    },
    extends: PatientRowCells
}
</script>
